<div *ngIf="progress" class="row">
  <div class="col">
    <migrations-last-progress
      [progress]="progress"
      [progressIsLoading]="progressIsLoading"
      (updateMigrationProgress)="updateMigrationProgress.emit($event)"
    >
    </migrations-last-progress>
  </div>
</div>

<ng-container *ngIf="pasMigrationsProgress">
  <h3>Last PAS run</h3>
  <div class="row">
    <div class="col">
      <app-migrations-accounts-table
        [fixedHeader]="false"
        [showAccountId]="false"
        [migrations]="[pasMigrationsProgress]"
        [isLoadingAccounts]="pasProgressIsLoading"
        (openMigrationModal)="openMigrationModal.emit($event)"
        (getMigrationReport)="getMigrationReport.emit($event)"
      >
      </app-migrations-accounts-table>
    </div>
  </div>
</ng-container>

<div class="row">
  <div class="col">
    <h3>Migration history</h3>
  </div>
</div>

<div class="row">
  <div class="col-3">
    <select class="form-control" [formControl]="period">
      <option value="1">Last month</option>
      <option value="3">Last 3 month</option>
      <option value="6">Last 6 month</option>
      <option value="12">Last 12 month</option>
    </select>
  </div>
</div>
<app-table [useFixedHeader]="true">
  <app-table-headers>
    <app-table-header class="flex-half">Pro Account ID</app-table-header>
    <app-table-header class="flex-half">Section ID</app-table-header>
    <app-table-header class="flex-half flex-center">Status</app-table-header>
    <app-table-header class="flex-half flex-center"
      >Created at</app-table-header
    >
    <app-table-header class="flex-half flex-center"
      >Finished at</app-table-header
    >
    <app-table-header class="flex-half flex-center">Type</app-table-header>
    <app-table-header>
      <i class="fas fa-link"></i>
      CW Log
    </app-table-header>
  </app-table-headers>

  <ng-template #empty>
    <app-table-content-empty [isLoading]="isLoadingMigrations">
      <ng-container loading><p>Fetching migrations ...</p></ng-container>

      <ng-container nodata *ngIf="!isLoadingMigrations">
        <p>No migrations were found in the selected time period</p>
      </ng-container>
    </app-table-content-empty>
  </ng-template>

  <app-table-content *ngIf="!isLoadingMigrations; else empty">
    <ng-container *ngIf="migrations && migrations.length; else empty">
      <app-table-row *ngFor="let migration of migrations">
        <app-table-cell class="flex-half">
          <strong>
            {{ migration.proAccountId }}
          </strong>
        </app-table-cell>
        <app-table-cell class="flex-half">
          <strong>
            {{ migration.sectionId }}
          </strong>
        </app-table-cell>
        <app-table-cell
          class="flex-half flex-center"
          [ngbTooltip]="
            migration.status === MigrationState.Failed
              ? migration.statusReason
              : ''
          "
        >
          <span
            [ngClass]="
              'badge badge-' + getMigrationStateClass(migration.status)
            "
          >
            {{ migration.status }}
          </span>
        </app-table-cell>
        <app-table-cell class="flex-half flex-center">
          {{ migration.createdAt | date: 'yyyy-MM-dd' }}
          <br />
          {{ migration.createdAt | date: 'HH:mm' }}
        </app-table-cell>
        <app-table-cell class="flex-half flex-center">
          {{ migration.finishedAt | date: 'yyyy-MM-dd' }}
          <br />
          {{ migration.finishedAt | date: 'HH:mm' }}
        </app-table-cell>
        <app-table-cell class="flex-half flex-center">
          <b>{{ migration.type }}</b>
        </app-table-cell>
        <app-table-cell>
          <ng-container *ngIf="migration.logStreamUrl">
            <button
              (click)="copyLogGroupUrl(migration.logStreamUrl)"
              type="button"
              class="btn btn-sm btn-outline-primary"
              [ngbTooltip]="'Copy to clipboard'"
            >
              <i
                class="fa fa-copy icon"
                placement="top"
                triggers="click"
                [autoClose]="'outside'"
                [ngbTooltip]="'Copied to clipboard'"
              ></i>
            </button>
            <span class="link" (click)="openInNewTab(migration.logStreamUrl)">
              Cloudwatch log url
            </span>
          </ng-container>
          <ng-container *ngIf="!migration.logStreamUrl">
            <div class="w-100">
              <i class="fa fa-exclamation icon" [style.color]="'red'"></i>
              No url
            </div>
          </ng-container>
        </app-table-cell>
      </app-table-row>
    </ng-container>
  </app-table-content>
</app-table>
